      <igx-tree class="tree-root">
      
      <igx-tree-node class="mimic-button-hover"  [routerLink]="'/home'">
            <span class="ace-menu-level-1">Home</span>
      </igx-tree-node>

      <igx-tree-node>
            <span class="ace-menu-level-1">Profiles</span>
            <igx-tree-node class="mimic-button-hover" (click)="onNavToCompanyProfile()">
                  <span class="ace-menu-level-2">Company</span>
            </igx-tree-node>

                  <igx-tree-node class="mimic-button-hover"  (click)="onNavToNewParkerProfile()">
                        <span class="ace-menu-level-2">Parker</span>
                  </igx-tree-node>
            </igx-tree-node>
      
      <igx-tree-node>
            <span class="ace-menu-level-1">Invoices</span>

            <!-- <igx-tree-node class="mimic-button-hover" (click)="onNavToGB()">
                  <span class="ace-menu-level-2">Generate Billings</span>
            </igx-tree-node>

            <igx-tree-node  class="mimic-button-hover" (click)="onNavToMI()">
                  <span class="ace-menu-level-2">Manual Invoice</span>
            </igx-tree-node>

            <igx-tree-node  class="mimic-button-hover" (click)="onNavToLegacySendInvoices()">
                  <span class="ace-menu-level-2">Send Invoice(s)</span>
            </igx-tree-node> -->

            <igx-tree-node class="mimic-button-hover" [routerLink]="'sandbox/gbcreation'" >
                  <span class="ace-menu-level-2">Generate GB Invoices</span>
            </igx-tree-node>

            <igx-tree-node  class="mimic-button-hover" [routerLink]="'/invoice/generateprelimmi'" >
                  <span class="ace-menu-level-2">Generate MI Invoices</span>
            </igx-tree-node>

            <igx-tree-node  class="mimic-button-hover" [routerLink]="'/sendinvoices-v2'" >
                  <span class="ace-menu-level-2">Send Invoice(s)</span>
            </igx-tree-node>

      </igx-tree-node>

      
      <igx-tree-node class="mimic-button-hover"  (click)="onNavToInvoiceSearch()">
            <span class="ace-menu-level-1">Invoice Search</span>
      </igx-tree-node>
      

      <igx-tree-node  class="mimic-button-hover" >
            <span class="ace-menu-level-1">Reports</span>
                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'reportaging'" >
                        <span class="ace-menu-level-3">Aging Report</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'reportparkingagreement'" >
                        <span class="ace-menu-level-3">Parking Agreement</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'reportpayments'" >
                        <span class="ace-menu-level-3">Payment Report</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'reporttenant'" >
                        <span class="ace-menu-level-3">Tenant Roster</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'reportrecurringtasks'"  *ngIf="this._appGeneralState.isSuperUser ==  true" >
                        <span class="ace-menu-level-3">Automated Tasks</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  (click)="onNavToReports()" >
                        <span class="ace-menu-level-3">Legacy Reports</span>
                  </igx-tree-node>
            </igx-tree-node>


      <igx-tree-node>
            <span class="ace-menu-level-1">Utilities</span>
                  
                  <igx-tree-node  class="mimic-button-hover" (click)="onNavToMarketRates()">
                        <span class="ace-menu-level-2">Market</span>
                  </igx-tree-node>
                  <igx-tree-node  class="mimic-button-hover"  (click)="onNavToCompanyRates()"> 
                        <span class="ace-menu-level-2">Company</span>
                  </igx-tree-node>
                  <igx-tree-node  class="mimic-button-hover"  (click)="onNavToLotSetup()">
                        <span class="ace-menu-level-2">Lot Setup</span>
                  </igx-tree-node>
                  @if(this._appGeneralState.currentLotHasParcs) {
                        <igx-tree-node>
                              <span class="ace-menu-level-2">PARCS</span>
                              <igx-tree-node *ngIf="this._appGeneralState.isSuperUser ==  true" class="mimic-button-hover"  (click)="onNavToParcsSyncSetup()">
                                    <span class="ace-menu-level-2">Amano One Sync</span>
                              </igx-tree-node>
                              <igx-tree-node  *ngIf="this._appGeneralState.isSuperUser ==  true"  class="mimic-button-hover"  (click)="onNavToFlashParkingSyncSetup()">
                                    <span class="ace-menu-level-2">Flash Parking Sync</span>
                              </igx-tree-node>
                              <igx-tree-node  class="mimic-button-hover"  (click)="onNavToFlashParkingUtilities()">
                                    <span class="ace-menu-level-2">Flash Parking Utilities</span>
                              </igx-tree-node>
                        </igx-tree-node>
                  }
      </igx-tree-node>
      

      <hr />
      <igx-tree-node *ngIf="this._appGeneralState.isUserAdmin ==  true">
            <span class="ace-menu-level-1">Admin</span>
            
            <igx-tree-node>
                  <span class="ace-menu-level-2">spACE</span>

                  <igx-tree-node  class="admin-tree-font mimic-button-hover"  [routerLink]="'/adminhome/2/space'" >
                        <span class="ace-menu-level-3">Mass Activation</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminhome/1/spaceemailupdate'" >
                        <span class="ace-menu-level-3">Update spACE Email</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminhome/1/spacecompanyadminprofile'" >
                        <span class="ace-menu-level-3">Company Admin Email Search</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminhome/1/spaceparkerprofilesettings'" >
                        <span class="ace-menu-level-3">Parker spACE Settings</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'adminhome/1/spacecompanyprofilesettings'">
                        <span class="ace-menu-level-3">Company spACE Settings</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'adminhome/1/spacedisablelots'">
                        <span class="ace-menu-level-3">spACE Disable Lots</span>
                  </igx-tree-node>
                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'adminhome/1/enablemultiplespaceuser'">
                        <span class="ace-menu-level-3">spACE Company Multiple Lots</span>
                  </igx-tree-node>
                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'adminfixspaceaccounts'" *ngIf="this._appGeneralState.isSuperUser ==  true">
                        <span class="ace-menu-level-3">Fix spACE Accounts</span>
                  </igx-tree-node>
            </igx-tree-node>
            
            <igx-tree-node >
                  <span class="ace-menu-level-2">Invoice</span>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminhome/1/payments'" >
                        <span class="ace-menu-level-3">Payment Override</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminhome/1/invoicesearch'" *ngIf="this._appGeneralState.isSuperUser ==  true">
                        <span class="ace-menu-level-3">Invoice Search</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminminreadonlylot'">
                        <span class="ace-menu-level-3">MI Invoice Date Edit Status</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'admin/invoicelinecustomization'">
                        <span class="ace-menu-level-3">GB Invoice Line Customization</span>
                  </igx-tree-node>

                     <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'admin/currentInvoices'">
                        <span class="ace-menu-level-3">Current Invoices</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'admin/gbInvoiceJobs'">
                        <span class="ace-menu-level-3">GB Invoice Jobs</span>
                  </igx-tree-node>
            </igx-tree-node>

            <igx-tree-node>
                  <span class="ace-menu-level-2">Parker Profile</span>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminhome/1/parkerprofilesearch'" >
                        <span class="ace-menu-level-3">Search - Last/First</span>
                  </igx-tree-node>
                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminhome/1/parkeremaillicenseplatesearch'" >
                        <span class="ace-menu-level-3">Search - Email/License Plate</span>
                  </igx-tree-node>
                  
            </igx-tree-node>

            <igx-tree-node >
                  <span class="ace-menu-level-2">Company Profile</span>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminhome/1/alllotscompanysearch'" >
                        <span class="ace-menu-level-3">All Lot Company Search</span>
                  </igx-tree-node>
            
            </igx-tree-node>

            <igx-tree-node class=" mimic-button-hover" >
                  <span class="ace-menu-level-2">Lot Setup</span>

                  <igx-tree-node class="admin-tree-font mimic-button-hover"  (click)="onNavToLegacyLotSetup()" >
                        <span class="ace-menu-level-3">Old Lot Setup</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'adminhome/2/parkeragreementtemplate'" *ngIf="this._appGeneralState.isSuperUser ==  true">
                        <span class="ace-menu-level-3">Monthly Agreement</span>
                  </igx-tree-node>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'usersforlotnumber'">
                        <span class="ace-menu-level-3">Users by Lot</span>
                  </igx-tree-node>


            </igx-tree-node>

        

              <igx-tree-node class=" mimic-button-hover" >
                  <span class="ace-menu-level-2">PARCS</span>

                  <!-- <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'adminparcsmanager'" *ngIf="this._appGeneralState.isSuperUser ==  true">
                              <span class="ace-menu-level-3"><strong>PARCS Manager</strong></span>
                  </igx-tree-node> -->

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"   [routerLink]="'adminparcshome'" *ngIf="this._appGeneralState.isSuperUser ==  true">
                              <span class="ace-menu-level-3"><strong>PARCS Lot Setup</strong></span>
                  </igx-tree-node>

            </igx-tree-node>

             <igx-tree-node *ngIf="this._appGeneralState.isSuperUser ==  true">
                  <span class="ace-menu-level-2">Reports</span>

                  <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'report/webjobstatus'" >
                        <span class="ace-menu-level-3">Automated Tasks</span>
                  </igx-tree-node>
                  <!-- <igx-tree-node  class="admin-tree-font  mimic-button-hover"  [routerLink]="'adminhome/1/parkeremaillicenseplatesearch'" >
                        <span class="ace-menu-level-3">Search - Email/License Plate</span>
                  </igx-tree-node> -->
                  
            </igx-tree-node>

                <igx-tree-node class=" mimic-button-hover"  [routerLink]="'adminhome/1/assignaccess'">
                  <span class="ace-menu-level-2">Assign Access</span>
            </igx-tree-node>

             <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'adminhome/1/configenvironment'"  *ngIf="this._appGeneralState.isSuperUser ==  true" >
                        <span class="ace-menu-level-2">Config</span>
                  </a>
            </igx-tree-node>

             <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'admin/tasks/settings'"  *ngIf="this._appGeneralState.isSuperUser ==  true" >
                        <span class="ace-menu-level-2">Task Settings</span>
                  </a>
            </igx-tree-node>
            
           
      
      </igx-tree-node>

       <igx-tree-node *ngIf="this._appGeneralState.isSuperUser ==  true">
            <span class="ace-menu-level-1">Sandbox</span>
           
             <!-- <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'sandbox/gbcreationsandbox'">
                        <span class="ace-menu-level-2">New GB Creation</span>
                  </a>
            </igx-tree-node>

             <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'sandbox/micreationsandbox'">
                        <span class="ace-menu-level-2">New MI Creation</span>
                  </a>
            </igx-tree-node> -->

             <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'sandbox/sendinvoice'">
                        <span class="ace-menu-level-2">Send Invoices</span>
                  </a>
            </igx-tree-node>

            <!-- <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'sandbox/quicksearch'">
                        <span class="ace-menu-level-2">QuickSearch - New Lot</span>
                  </a>
            </igx-tree-node>
            <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'sandbox/newratehome'">
                        <span class="ace-menu-level-2">Rates New Home</span>
                  </a>
            </igx-tree-node>
            <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'sandbox/ratehome1'">
                        <span class="ace-menu-level-2">Rates Concept 1</span>
                  </a>
            </igx-tree-node>
            <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'sandbox/ratehome2'">
                        <span class="ace-menu-level-2">Rates Concept 2</span>
                  </a>
            </igx-tree-node> -->

            

                <igx-tree-node>
                  <a class="nav-link active" [routerLink]="'sandbox/taxappliedcheckbox'">
                        <span class="ace-menu-level-2">Tax Applied Test</span>
                  </a>
            </igx-tree-node>

            

            
      </igx-tree-node>
      </igx-tree>
      @if(this._appGeneralState.isSuperUser){
            <div class="last-build-date">
                  Last Updated: <br />
                  {{ lastbuildDate }}
            </div>
      }






